module.exports = __webpack_public_path__ + "media/宣传片.67b60b4b.mp4";